import { alpha } from "@mui/material/styles";

export const styles = {
  dialogContent: {
    p: 0,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    overflow: "visible",
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    width: "auto",
  },
  mobileCloseButton: {
    display: { xs: "inline-flex", sm: "none" },
    color: "text.secondary",
    mb: 1.5,
  },
  titleIcon: {
    color: "primary.main",
    fontSize: "2rem",
  },
  titleText: {
    color: "primary.main",
    fontWeight: 600,
    lineHeight: 1.1,
    flex: 1,
    ml: 1,
    pt: 0.75,
  },
  summaryContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    justifyContent: "flex-start",
    width: "100%",
    flexWrap: "wrap",
    gap: { xs: 2, sm: 5 },
    py: 0.75,
  },
  summaryLabel: {
    color: "text.secondary",
    fontWeight: "bold",
    mb: 0.25,
  },
  summaryValue: {
    color: "text.secondary",
  },
  heading: {
    color: "primary.main",
    fontSize: { xs: "1.125rem", sm: "1.25rem" },
    fontWeight: 550,
    lineHeight: 1.2,
    mt: 0.5,
    mb: 1,
  },
  languageDescription: {
    color: "text.secondary",
    fontSize: "0.95rem",
    mb: 1,
  },
  menuItem: {
    "&.Mui-selected": {
      backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.2),
    },
    "&.Mui-selected:hover": {
      backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.3),
    },
  },
  reasonGroup: {
    gap: { xs: 1, sm: 0 },
  },
  radioButtonChecked: {
    "&.Mui-checked": {
      color: "secondary.main",
    },
  },
  actionsContainer: {
    display: "flex",
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: { xs: "center", sm: "flex-end" },
    alignItems: "center",
    gap: { xs: 1, sm: "20px" },
    px: 0,
    pt: { xs: "16px", sm: "20px" },
    pb: 0,
  },
  cancelTextButton: {
    display: { xs: "none", sm: "inline-flex" },
  },
  actionButton: {
    width: { xs: "100%", sm: "auto" },
  },
};
